export default "__VITE_PUBLIC_ASSET__95e941b7__"